module.exports = __webpack_public_path__ + "static/media/portfolio2.59022ce0.PNG";